import _ from 'lodash'
import { cn } from '@/lib/utils'
import type { CasinoGame } from '@/types/casino'
import { CasinoGameCard } from './CasinoGameCard'
import { CasinoGameCardSkeleton } from './CasinoGameCardSkeleton'

interface CasinoGameCardListProps {
	games: CasinoGame[]
	isLoading?: boolean
	isError?: boolean
	emptyMessage?: string
	className?: string
	cardClassName?: string
	layout?: 'carousel' | 'grid'
	skeletonCount?: number
}

export function CasinoGameCardList({
	games,
	isLoading = false,
	isError = false,
	emptyMessage = 'No games available right now.',
	className,
	cardClassName,
	layout = 'carousel',
	skeletonCount = 9,
}: CasinoGameCardListProps) {
	if (isError) {
		return <p className='text-sm text-muted-foreground'>Unable to load casino games right now.</p>
	}

	if (isLoading) {
		return (
			<div className={cn(layout === 'grid' ? 'grid grid-cols-[repeat(auto-fill,150px)] justify-center gap-6' : 'flex gap-6', className)}>
				{_.times(skeletonCount, (index) => (
					<CasinoGameCardSkeleton key={`casino-game-skeleton-${index}`} className={cardClassName} />
				))}
			</div>
		)
	}

	if (_.isEmpty(games)) {
		return <p className='text-sm text-muted-foreground'>{emptyMessage}</p>
	}

	return (
		<div className={cn(layout === 'grid' ? 'grid grid-cols-[repeat(auto-fill,150px)] justify-center gap-6' : 'flex gap-6', className)}>
			{_.map(games, (game) => (
				<CasinoGameCard key={game.id} game={game} className={cardClassName} />
			))}
		</div>
	)
}
